import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireAuth } from "@/common/routes/requireAuth";

export const Route = createFileRoute("/app/account/twc/join")({
  beforeLoad: ({ context }) => {
    requireAuth(context);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
